<template>
  <v-btn
    @click="$emit(`click`)"
    :block="!width && block"
    :disabled="disabled"
    :loading="loading"
    :height="height"
    :width="width"
    :to="to"
    depressed
    :class="{ 'primary-btn': !disabled, 'disabled-btn': disabled }"
  >
    <span 
      :class="{ [textClass]: true, 'primary-btn__content': !disabled, 'disabled-btn__content': disabled }"
    >
      <slot></slot>
    </span>
  </v-btn>
</template>

<style lang="scss" scoped>
.disabled-btn {
  background-color: var(--v-inactive-button-base) !important;
  padding-left: 20px !important;
  padding-right: 20px !important; 
  border-radius: 6px;

    &__content {
    color: var(--v-inactive-button-text-base) !important;
  }
}
.primary-btn {
  background-color: var(--v-primary-button-base) !important;
  padding-left: 20px !important;
  padding-right: 20px !important; 
  border-radius: 6px;

  &__content {
    color: var(--v-primary-button-text-base) !important;
  }
}
</style>

<script lang="ts">
import Vue from 'vue'

export default Vue.extend({
  name: 'PrimaryButton',

  props: {
    block: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    height: {
      type: Number,
      default: 50,
    },
    width: {
      type: Number,
    },
    textClass: {
      type: String,
      default: 'text-h3',
    },
    to: {
      type: String,
      default: '',
      required: false,
    },
    rounded: {
      type: Number,
      default: 1
    },
  },
})
</script>
